import { IoEyeOutline } from "react-icons/io5";
import { Popover } from "antd";
import List from "../../../assets/List.svg";

type Props = { data: any };

const PopoverServicesIncluded = ({ data }: Props) => {
  const content = (
    <div className="grid items-center gap-2">
      {data?.pricing_option?.map((e: any) => (
        <div className="flex items-center justify-between text-xs bg-[#EEF0FF] p-2 rounded-lg gap-8">
          <div className="flex items-center gap-2">
            <img src={List} alt="" />
            <span className="font-semibold text-[#020418] text-xs">
              {e?.service?.name}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-color-primary flex items-center gap-1">
              <span className="w-2 h-2 bg-[#A9AEF6] rounded-full inline-block" />
              <span>Hair</span>
            </span>
            <span className="text-color-primary flex items-center gap-1">
              <span className="w-2 h-2 bg-[#9999A7] rounded-full inline-block" />
              <span className="flex items-center gap-[1px]">
                <span>{e?.price}</span>
                <span className="text-[8px] mt-auto">SR</span>
              </span>
            </span>
            <span className="text-color-primary flex items-center gap-1">
              <span className="w-2 h-2 bg-[#9999A7] rounded-full inline-block" />
              <span className="flex items-center gap-[1px]">
                <span>{e?.duration}</span>
                <span className="text-[8px] mt-auto">Mins</span>
              </span>
            </span>
          </div>
        </div>
      ))}
    </div>
  );
  return data?.services?.length > 0 ? (
    <Popover
      placement="top"
      className=""
      title={
        <p className="text-color-primary text-sm font-semibold">
          Services Included
        </p>
      }
      content={content}
    >
      <div className="text-[#9999A7] text-sm font-medium flex items-center justify-center gap-1">
        <span className="text-color-primary mx-1 font-semibold">
          {data?.services?.length}
        </span>
        <IoEyeOutline className="text-[#9999A7] flex items-center justify-center" />
      </div>
    </Popover>
  ) : (
    <div className="text-[#9999A7] text-sm font-medium flex items-center justify-center gap-1">
      <span className="text-color-primary mx-1 font-semibold">0</span>
      <IoEyeOutline className="text-[#9999A7] flex items-center justify-center" />
    </div>
  );
};

export default PopoverServicesIncluded;
